export default __webpack_public_path__ + "static/media/ohoskin.81bc090a.png";